import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import MainPage from '@/views/mainPage/Index.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'index',
        component: MainPage,
        meta: { titleKey: 'router.home' },
    },
    {
        path: '/en',
        name: 'index-en',
        component: MainPage,
        meta: { titleKey: 'router.home', locale: 'en' },
    },
    {
        path: '/cenik',
        name: 'cenik',
        component: () => import(/* webpackChunkName: "cenik" */ '@/views/Cenik.vue'),
        meta: { titleKey: 'router.cenik' },
    },
    {
        path: '/en/price-list',
        name: 'cenik-en',
        component: () => import(/* webpackChunkName: "cenik" */ '@/views/Cenik.vue'),
        meta: { titleKey: 'router.cenik', locale: 'en' },
    },
    {
        path: '/o-nas',
        name: 'o-nas',
        component: () => import(/* webpackChunkName: "cenik" */ '@/views/ONas.vue'),
        meta: {
            titleKey: 'router.oNas',
            descriptionKey: 'router.oNasDescription',
        },
    },
    {
        path: '/en/about-us',
        name: 'o-nas-en',
        component: () => import(/* webpackChunkName: "cenik" */ '@/views/ONas.vue'),
        meta: {
            titleKey: 'router.oNas',
            descriptionKey: 'router.oNasDescription',
            locale: 'en',
        },
    },
    {
        path: '/pregledi',
        name: 'pregledi',
        component: () => import(/* webpackChunkName: "pregledi" */ '@/views/Pregledi.vue'),
        meta: { titleKey: 'router.pregledi' },
    },
    {
        path: '/en/dental-check-ups',
        name: 'pregledi-en',
        component: () => import(/* webpackChunkName: "pregledi" */ '@/views/Pregledi.vue'),
        meta: { titleKey: 'router.pregledi', locale: 'en' },
    },
    {
        path: '/karies',
        name: 'karies',
        component: () => import(/* webpackChunkName: "karies" */ '@/views/Karies.vue'),
        meta: { titleKey: 'router.karies' },
    },
    {
        path: '/en/caries-treatment',
        name: 'karies-en',
        component: () => import(/* webpackChunkName: "karies" */ '@/views/Karies.vue'),
        meta: { titleKey: 'router.karies', locale: 'en' },
    },
    {
        path: '/ortopan',
        name: 'ortopan',
        component: () => import(/* webpackChunkName: "ortopan" */ '@/views/Ortopan.vue'),
        meta: { titleKey: 'router.ortopan' },
    },
    {
        path: '/en/panoramic-radiography',
        name: 'ortopan-en',
        component: () => import(/* webpackChunkName: "ortopan" */ '@/views/Ortopan.vue'),
        meta: { titleKey: 'router.ortopan', locale: 'en' },
    },
    {
        path: '/beljenje',
        name: 'beljenje',
        component: () => import(/* webpackChunkName: "beljenje" */ '@/views/Beljenje.vue'),
        meta: { titleKey: 'router.beljenje' },
    },
    {
        path: '/en/teeth-whitening',
        name: 'beljenje-en',
        component: () => import(/* webpackChunkName: "beljenje" */ '@/views/Beljenje.vue'),
        meta: { titleKey: 'router.beljenje', locale: 'en' },
    },
    {
        path: '/parodontologija',
        name: 'parodontologija',
        component: () => import(/* webpackChunkName: "parodontologija" */ '@/views/Parodontologija.vue'),
        meta: { titleKey: 'router.parodontologija' },
    },
    {
        path: '/en/periodontology',
        name: 'parodontologija-en',
        component: () => import(/* webpackChunkName: "parodontologija" */ '@/views/Parodontologija.vue'),
        meta: { titleKey: 'router.parodontologija', locale: 'en' },
    },
    {
        path: '/otrosko',
        name: 'otrosko',
        component: () => import(/* webpackChunkName: "otrosko" */ '@/views/Otrosko.vue'),
        meta: { titleKey: 'router.otrosko' },
    },
    {
        path: '/en/dental-care-for-children',
        name: 'otrosko-en',
        component: () => import(/* webpackChunkName: "otrosko" */ '@/views/Otrosko.vue'),
        meta: { titleKey: 'router.otrosko', locale: 'en' },
    },
    {
        path: '/myobrace',
        name: 'myobrace',
        component: () => import(/* webpackChunkName: "myobrace" */ '@/views/Myobrace.vue'),
        meta: { titleKey: 'router.myobrace' },
    },
    {
        path: '/en/myobrace',
        name: 'myobrace-en',
        component: () => import(/* webpackChunkName: "myobrace" */ '@/views/Myobrace.vue'),
        meta: { titleKey: 'router.myobrace', locale: 'en' },
    },
    {
        path: '/invisalign',
        name: 'invisalign',
        component: () => import(/* webpackChunkName: "invisalign" */ '@/views/Invisalign.vue'),
        meta: {
            titleKey: 'router.invisalignTitle',
            descriptionKey: 'router.invisalignDesc',
        },
    },
    {
        path: '/en/invisalign',
        name: 'invisalign-en',
        component: () => import(/* webpackChunkName: "invisalign" */ '@/views/Invisalign.vue'),
        meta: {
            titleKey: 'router.invisalignTitle',
            descriptionKey: 'router.invisalignDesc',
            locale: 'en',
        },
    },
    {
        path: '/lasersko',
        name: 'lasersko',
        component: () => import(/* webpackChunkName: "lasersko" */ '@/views/Lasersko.vue'),
        meta: {
            titleKey: 'router.laserTitle',
            descriptionKey: 'router.laserDesc',
        },
    },
    {
        path: '/en/laser-dentistry',
        name: 'lasersko-en',
        component: () => import(/* webpackChunkName: "lasersko" */ '@/views/Lasersko.vue'),
        meta: {
            titleKey: 'router.laserTitle',
            descriptionKey: 'router.laserDesc',
            locale: 'en',
        },
    },
    {
        path: '/frenulotomija',
        name: 'frenulotomija',
        component: () => import(/* webpackChunkName: "frenulotomija" */ '@/views/Frenulotomija.vue'),
        meta: {
            titleKey: 'router.frenulotomijaTitle',
            descriptionKey: 'router.frenulotomijaDesc',
        },
    },
    {
        path: '/en/laser-frenulotomy',
        name: 'frenulotomija-en',
        component: () => import(/* webpackChunkName: "frenulotomija" */ '@/views/Frenulotomija.vue'),
        meta: {
            titleKey: 'router.frenulotomijaTitle',
            descriptionKey: 'router.frenulotomijaDesc',
            locale: 'en',
        },
    },
    {
        path: '/protetika',
        name: 'protetika',
        component: () => import(/* webpackChunkName: "protetika" */ '@/views/Protetika.vue'),
        meta: {
            titleKey: 'router.protetikaTitle',
            descriptionKey: 'router.protetikaDesc',
        },
    },
    {
        path: '/en/dental-crowns-bridges',
        name: 'protetika-en',
        component: () => import(/* webpackChunkName: "protetika" */ '@/views/Protetika.vue'),
        meta: {
            titleKey: 'router.protetikaTitle',
            descriptionKey: 'router.protetikaDesc',
            locale: 'en',
        },
    },
    {
        path: '/endodontsko',
        name: 'endodontsko',
        component: () => import(/* webpackChunkName: "endodontsko" */ '@/views/Endodontsko.vue'),
        meta: { titleKey: 'router.endodontsko' },
    },
    {
        path: '/en/endodontic-treatment',
        name: 'endodontsko-en',
        component: () => import(/* webpackChunkName: "endodontsko" */ '@/views/Endodontsko.vue'),
        meta: { titleKey: 'router.endodontsko', locale: 'en' },
    },
    {
        path: '/injekcijska-tehnika',
        name: 'injekcijska-tehnika',
        component: () =>
            import(/* webpackChunkName: "injekcijska-tehnika" */ '@/views/InjekcijskaTehnika.vue'),
        meta: {
            titleKey: 'router.injekcijskaTehnikaTitle',
            descriptionKey: 'router.injekcijskaTehnikaDesc',
        },
    },
    {
        path: '/en/injection-bonding-technique',
        name: 'injekcijska-tehnika-en',
        component: () =>
            import(/* webpackChunkName: "injekcijska-tehnika" */ '@/views/InjekcijskaTehnika.vue'),
        meta: {
            titleKey: 'router.injekcijskaTehnikaTitle',
            descriptionKey: 'router.injekcijskaTehnikaDesc',
            locale: 'en',
        },
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/views/Admin.vue'),
        meta: { title: 'Sočutno admin' },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
